export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/hu.342003d4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};